// Deployed containers write /config.js from their Fly secrets at start (docker/runtime-config.sh),
// so one image serves any environment. Local dev and tests have none and fall back to Vite's env.
type Env = ImportMetaEnv & Record<string, string | undefined>;

const injected = (): Record<string, string | undefined> =>
  (typeof window !== 'undefined' && (window as { __LUREO_CONFIG__?: Record<string, string> }).__LUREO_CONFIG__) || {};

export const runtimeEnv = new Proxy({} as Env, {
  get: (_, key) => typeof key === 'string'
    ? injected()[key] ?? (import.meta.env as Record<string, unknown> | undefined)?.[key]
    : undefined,
});
